import { cn } from '../../lib/utils'
import { Avatar, AvatarFallback, AvatarImage } from './avatar'

export const CryptoIcon = ({
  symbol,
  className,
  imageOverride,
  size = 'h-5 w-5',
}: {
  symbol: string
  className?: string
  imageOverride?: string
  size?: string
}) => {
  const iconSize = size || 'w-5 h-5'
  const iconStyle =
    'rounded-full flex items-center justify-center text-xs font-bold text-white ' + iconSize

  // Get first character of symbol for fallback, or use $ as default
  return (
    <Avatar className={cn(iconStyle, className)}>
      <AvatarImage src={imageOverride || `/currency/${symbol}.svg`} alt={symbol} />
      <AvatarFallback className="bg-main  text-white border border-white/20 shadow-sm">
        <div
          className={`rounded-full flex items-center justify-center text-xs font-bold text-white leading-none ${iconSize}`}
        >
          $
        </div>
      </AvatarFallback>
    </Avatar>
  )
}
